/** What the extractor hands to the Author with AI upload path; the API mirrors these limits in contracts/document.ts. */

export type DocumentType = 'pdf' | 'docx' | 'pptx' | 'txt';

export const DOCUMENT_MIME_TYPES: Readonly<Record<DocumentType, string>> = {
  pdf: 'application/pdf',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  txt: 'text/plain',
};

/** The file picker's accept list: extensions and MIME types of the four document types. */
export const DOCUMENT_ACCEPT = ['.pdf', '.docx', '.pptx', '.txt', ...Object.values(DOCUMENT_MIME_TYPES)].join(',');

export interface DocumentSection {
  number: number;
  text: string;
}

/** An image found in the document; kept for the extractors, not sent anywhere in this pass. */
export interface ExtractedImage {
  id: string;
  sectionNumber: number;
  blob: Blob;
  mimeType: string;
  width: number;
  height: number;
}

export interface ExtractedDocument {
  fileName: string;
  documentType: DocumentType;
  sections: DocumentSection[];
}
